<template>
	<div class="selectVinCheckbox" :class="[vinSelected ? 'selectedVin' : '']" @click="toggleVinSelection">
        <div v-if="vinSelected" class="vinSelectCheck">
            &#10003;
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props: [
            'vin'
        ],
        computed: {
            vinSelected() {
                return this.$store.getters.isVinSelected(this.vin);
            }
        },
        methods: {
            toggleVinSelection() {
                this.$gtag.event('toggle', {'event_category': 'vehicle'});
                this.$store.commit('toggleVinSelection', this.vin);
            }
        }           
    }
</script>

<style scoped>
    .selectVinCheckbox {
        height: calc(.9 * var(--vw));
        width: calc(.8 * var(--vw));
        border: solid thin black;
        border-radius: calc(var(--vratio) * var(--vh));/*4px;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .selectVinCheckbox:hover {
        border-color: var(--mccluskeyGold); /*#AF873F;*/
        cursor: pointer;
    }

    .selectVinCheckbox.selectedVin {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*//*#AF873F;*/
    }

    .vinSelectCheck {
        color: white;/*#3378B1;*/
        font-weight: bolder;
        font-size: calc(1.1 * var(--vw));
    }
</style>
